import useSWR from "swr";
import { useDateFilters } from "../../../hooks/useDateFilters";
import { formatDateRange } from "../../../../../utils/helpers/api";

export const usePayGroupItems = (user) => {
    const { from, to } = useDateFilters();
    const { data } = useSWR(() => {
        const id = user?.payGroup?.id || user?.payGroup;
        if (!id) {
            return null;
        }
        return {
            url: `/pay-group/${id}/items`,
            params: {
                ...formatDateRange(from, to),
                pagination: "false",
            },
        };
    });
    return data?.result;
}
